import {DateTime} from "luxon";

export function formatDate(date) {
  if (date) {
    return DateTime.fromFormat(date, 'yyyy-LL-dd').toFormat('dd/LL/yyyy')
  }
}
